<template>
  <!-- coupon -->
  <div class="">
    <!--删除列表时使用的是rowKey的id-->
    <x-tabula
      ref="table"
      rowKey=""
      :dataSource="dataSource"
      :searchList="searchList"
      :columns="columns"
      :tableOptList="tableOptList"
      :rowOptList="rowOptList"
      :searchParams.sync="searchParams"
      :listApi="listApi"

      :deleteParam="deleteParam"
      :rowSelection="false"
    >
      <template slot="opt_t" slot-scope="{row}">
        {{row.useLimit >0? `满${row.useLimit}，减${row.price}`:`无门槛，减${row.price}`}}
      </template>
      <template slot="opt_s" slot-scope="{row}">
        {{`${row.receivedNum}/${row.residueNum}`}}
      </template>
      <template slot="opt_status" slot-scope="{row}">
        <div style="display: flex; align-items: center">
          <span class="circle-dot" :class="statusColor[row.realStatus] + '-bg'"></span>
          <span>{{ statusObj[row.realStatus] }}</span>
        </div>
      </template>
    </x-tabula>

    <add-model ref='add'></add-model>
    <edit-model ref='edit'></edit-model>
  </div>
</template>

<script>
import addModel from './addModel.vue';
import editModel from './editModel.vue';
export default {
  name: 'localCoupon',
  components: {
    addModel, editModel
  },
  data () {
    return {
      visible: false,
      rowData: {},
      searchList: [
        {
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '名称',
          props: ['couponName']
        }, {
          inputType: 'select',
          options: [
            { value: '1', label: '满减' },
            { value: '2', label: '折扣' }
          ],
          handle: '',
          placeholder: '类型',
          props: ['couponType']
        }, {
          inputType: 'select',
          options: [
            { value: '0', label: '未开始' },
            { value: '1', label: '进行中' },
            { value: '2', label: '已结束' },
            { value: '3', label: '已停发' }
          ],
          handle: '',
          placeholder: '状态',
          props: ['status']
        }
      ],
      tableOptList: [
        {
          text: '新增',
          icon: 'plus',
          permi: ['community:localCoupon:add'],
          handle: () => { this.$refs.add.show(); }
        }
      ],
      rowOptList: [
        {
          text: '编辑',
          handle: row => { this.$refs.edit.show(row.couponId, row.receivedNum > 0); },
          rowOptDisHandle: row => row.status == 3,
          permi: ['community:localCoupon:edit']
        },
        {
          text: '停发',
          handle: row => this.stopSending(row.couponId),
          rowOptDisHandle: row => row.status == 3,
          permi: ['community:localCoupon:stopSend']
        }
      ],
      columns: [
        {
          title: '优惠券名称',
          dataIndex: 'couponName',
          align: '',
          width: ''
        }, {
          title: '类型',
          dataIndex: 'couponTypeDesc',
          align: '',
          width: ''
        }, {
          title: '优惠内容',
          dataIndex: 'expireDesc',
          align: '',
          width: '',
          scopedSlots: {customRender: 't'}
        },
        {
          title: '已领取/剩余',
          dataIndex: 'receivedNum',
          align: '',
          width: '',
          scopedSlots: {customRender: 's'}
        },
        {
          title: '已使用',
          dataIndex: 'useNum',
          align: '',
          width: ''
        },
        {
          title: '支付金额',
          dataIndex: 'payFee',
          align: '',
          width: ''
        },
        {
          title: '客单价',
          dataIndex: 'unitPrice',
          align: '',
          width: ''
        },
        {title: '状态', dataIndex: 'status', align: '', width: '200px', scopedSlots: {customRender: 'status'}},
        {
          title: '操作',
          dataIndex: 'action',
          align: '',
          width: '',
          scopedSlots: { customRender: 'action' }
        }
      ],
      statusObj: ['未开始', '进行中', '已结束', '已停发'],
      statusColor: ['info', 'success', 'danger', 'danger'],
      dataSource: [],
      searchParams: {
        couponName: undefined,
        couponType: undefined,
        status: undefined
      },
      listApi: {
        url: '/local/coupon/list',
        resHandle: '', // this.resHandle
        searchHandle: '' // searchHandle
      },
      deleteParam: {
        url: '/local/banner/',
        title: '该Banner图片',
        key: 'name',
        resHandle: '' // 执行完删除的回调方法
      }
    };
  },
  methods: {
    stopSending (id) {
      let that = this;
      this.$confirm({
        title: '停发',
        centered: true,
        content: h => <div style="color:333;">
            <p>停发后无法编辑优惠券内容，用户无法再领取该优惠券，但之前已领取的优惠券有效期内仍可继续使用。</p>
          </div>,
        onOk () {
          that.$post({
            url: '/local/coupon/stopSend',
            params: {
              couponId: id
            }
          }).then((res) => {
            if (res.code == 200) {
              that.$message.success('操作成功');
              that.$refs.table.getTableList();
            }
          });
        }
      });
    },
    /* 切换状态 */
    changeStatus (row) {
      let status = row.status === 1 ? 0 : 1;
      this.$put({
        url: `/local/banner/changeStatus/${row.bannerId}`,
        params: {
          status: status
        }
      }).then(({data}) => {
        this.$message.success('状态切换成功！');
        this.$refs.table.getTableList();
      });
    },
    updateTable (res) {
      if (res && res.code == 200) {
        this.$message.success(res.msg);
      }
      this.$refs.table.getTableList();
    },
    showbigimg (img, title) {
      this.$refs.bigImg.show(img, title);
    },
    /** 弹窗详情 */
    modalDetail (row) {
      this.visible = true;
      this.rowData = row;
    },
    resHandle (res) {
      return res;
    },
    searchHandle (selectData) {
      return selectData;
    }
  }
};
</script>

<style lang="scss" scoped>
</style>
